import HttpClient from "./HttpClient";
import environment from "./variables";
import StorageHelper from "./StorageHelper";

class GroupsManagement extends HttpClient {
    constructor() {
        super(environment.apiEndpoint!);
    }

    async getGroups(_filters?: string[], _values?: string[]) {
        try {
            return await this.client.get(`/groups`, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't get groups")
            throw (e);
        }
    }

    async deleteGroup(groupName: string) {
        try {
            return await this.client.delete(`/groups/${groupName}`, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't delete group")
            throw (e);
        }
    }

    async createGroup(groupName: string) {
        try {
            return await this.client.post(`/groups`, {
                group: groupName
            }, {
                headers: {
                    Authorization: `Bearer ${StorageHelper.getIdToken()}`
                }
            })
        } catch (e) {
            console.error("Can't create group")
            throw (e);
        }
    }
}

export default GroupsManagement;
